import React, {PureComponent} from 'react';

import ConfluenceLogo from '@atlassian/brand-logos/dist/products/confluence-white.svg';
import {routes} from '../../constants/';

import styles from './Header.less';

export class Header extends PureComponent {
    render() {
        return (
            <div className="aui-header">
                <div className="aui-header-logo">
                    <a href={routes.confluenceHome}>
                        <img alt="Confluence" className={styles.logo} src={ConfluenceLogo} />
                    </a>
                </div>
            </div>
        );
    }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js